import {Box} from '@chakra-ui/react'
import {yupResolver} from '@hookform/resolvers/yup'
import {get, isEmpty} from 'lodash-es'
import {FormProvider, useForm} from 'react-hook-form'
import React, {useCallback, useEffect} from 'react'
import {useRouter} from '_app/hooks/useRouter'
import {useCheckoutContext} from 'modules/checkout/hooks'
import {getDefaultShippingMethodForm} from 'modules/checkout/utils/shippingMethod'
import CountriesSelect from '../CountriesSelect'
import {schema} from './validation'
import {AvailableShippingMethods} from './AvailableShippingMethods'
import {useShippingMethod} from './hooks/useShippingMethod'
import {AvailableShippingMethod} from '../../../../_app/graphql/generated/graphql'
import {INPOST_CARRIER} from '../../constants'
import {useMutation} from '@apollo/client'
import {SET_SHIPPING_METHODS_ON_CART} from '../../../../_app/graphql/mutations/cart/SetShippingMethodsOnCart'

const ShippingMethodForm = () => {
    const {locale} = useRouter()
    const {
        cartCheckoutData: data,
        inpostAddressDetails,
        selectedShowroom,
    } = useCheckoutContext()
    const defaultValues = getDefaultShippingMethodForm(data)
    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues,
        reValidateMode: 'onSubmit',
    })
    const {
        availableShippingMethods,
        handleSubmit,
        selectedShippingMethod,
        errorMessageInpost,
    } = useShippingMethod(methods)
    const shippingMethod = methods.watch(
        'shipping_addresses[0].selected_shipping_method.carrier_code' as any
    )
    const [setShippingMethodsOnCart] = useMutation(SET_SHIPPING_METHODS_ON_CART)
    const shippingCountry = methods.watch('shipping_addresses[0].country.code' as any)
    const showroom_target = methods.watch('shipping_addresses[0].selected_shipping_method.showroom_target' as any)
    const submitForm = useCallback(() => {
        const values = methods.getValues()
        handleSubmit(values)
    }, [])
    useEffect(() => {
        if (shippingMethod && shippingMethod !== 'pickup') {
            submitForm()
        } else {
            if (showroom_target && shippingMethod && selectedShowroom) {
                const dataShowroomTarget = methods.getValues()
                const ssm: any = dataShowroomTarget?.shipping_addresses?.[0]?.selected_shipping_method
                const showRoomDataCart = data?.cart?.shipping_addresses?.[0]?.available_shipping_methods?.filter((el: any) => el.method_code === 'showroom')
                ssm.amount = showRoomDataCart?.[0]?.amount
                const variables = {
                    shippingMethods: [
                        {
                            carrier_code: 'pickup',
                            method_code: 'showroom',
                            showroom_target: showroom_target,
                            paczkomaty_target_point: null,
                        },
                    ],
                }
                setShippingMethodsOnCart({ variables, refetchQueries: ['GetCart'] })
            }
        }
    }, [
        shippingMethod,
        submitForm,
        inpostAddressDetails,
        selectedShowroom,
        shippingCountry,
        showroom_target,
    ])
    const loading = methods.formState.isSubmitting
    if (!data) {
        return <Box mt={{base: 8, md: 10}}/>
    }
    return (
        <Box mt={{base: 8, md: 10}} pos="relative">
            <FormProvider {...methods}>
                <form id="checkout[0]" onSubmit={handleSubmit}>
                    <Box
                        width={{lg: '50%'}}
                        mb={isEmpty(availableShippingMethods) ? 0 : {base: 8, md: 10}}
                        fontWeight={300}
                    >
                        <CountriesSelect
                            name="shipping_addresses[0].country.code"
                            showAll={locale !== 'de'}
                            shippingCode={shippingCountry as unknown as string}
                        />
                    </Box>
                    {
                        !isEmpty(availableShippingMethods) && (
                            <AvailableShippingMethods
                                loading={loading}
                                cart={data}
                                availableShippingMethods={availableShippingMethods}
                                selectedShippingMethod={selectedShippingMethod}
                                errorMessageInpost={errorMessageInpost}
                                setValue={methods.setValue}
                                submitForm={submitForm}
                            />
                        )
                    }
                </form>
            </FormProvider>
        </Box>
    )
}

export default ShippingMethodForm
